import { SSHKey } from '~/components/SSHKeysTable';

// SSH Cred data
export const sshInfo = {
  username: 'testing',
  status: 'enabled',
  success: true,
  credential: 'testing@50.87.243.217',
  ip: '50.87.243.217',
};

//GET SSH Keys List
export const sshKeysListData = {
  rows: [
    {
      name: 'id_rsa.pub',
      type: 'public',
      created_at: '2025-01-09T07:48:18',
      authorize: 1,
    },
    {
      name: 'id_rsa1.pub',
      type: 'public',
      created_at: '2025-01-01T10:24:08',
      authorize: 1,
    },
    {
      name: 'id_rsa10.pub',
      type: 'public',
      created_at: '2025-01-02T10:28:54',
      authorize: 1,
    },
    {
      name: 'id_rsa2.pub',
      type: 'public',
      created_at: '2025-01-03T10:26:28',
      authorize: 1,
    },
    {
      name: 'id_rsa3.pub',
      type: 'public',
      created_at: '2025-01-04T10:26:37',
      authorize: 1,
    },
    {
      name: 'id_rsa4.pub',
      type: 'public',
      created_at: '2025-01-05T10:26:45',
      authorize: 1,
    },
    {
      name: 'id_rsa5.pub',
      type: 'public',
      created_at: '2025-01-06T10:26:55',
      authorize: 1,
    },
    {
      name: 'id_rsa6.pub',
      type: 'public',
      created_at: '2025-01-07T10:27:02',
      authorize: 1,
    },
    {
      name: 'id_rsa7.pub',
      type: 'public',
      created_at: '2025-01-08T10:28:14',
      authorize: 1,
    },
    {
      name: 'id_rsa8.pub',
      type: 'public',
      created_at: '2025-01-10T10:28:24',
      authorize: 1,
    },
    {
      name: 'id_rsa9.pub',
      type: 'public',
      created_at: '2025-01-11T10:28:32',
      authorize: 1,
    },
  ],
};

// GET An SSH Key
export const ssheKeyInfo = {
  key_name: 'id_rsa.pub',
  type: 'public',
  key: 'ssh-rsa AAAAB3NzaC1yc2EAAAADAQABAAABAQCMz4Sn/fyACs7TnWnpDKf/aV8FFvrOZHWa0TlZeo+fiMUCwoQmo0xq9tCmCnO2JKs9du0qcjQQKdfVOoupzyLdPf05qfMkr+KzqPhndheOB2afpUHtoPxq/l+G5yK4JO9vw/AvJpSTr4/rClqN6i/VWfstNEbuOKZW170szZJV/jOrstG2+i9eLEpda/o9MNsX9n1AbL1aSigTKyV9pNwa1ws4mcHzUZubZuAyrjqJqUlW8pYi8+5QVJwGoJRXC3ZN2Eplgy8ZUkjVotl49D9jjIxeF5xjCgWZBKyMUaWbRtHZ0LUQADpqsGriftz6m6vybcz4c0J1plKyAi1oWNj3',
};

//GET VPS SSH Keys List
export const sshKeys: SSHKey[] = [
  {
    id: 1,
    name: 'My Laptop (Work)',
    alg_type: 'ED25519',
    addedAt: 'Jun 12, 2025',
    status: 'active',
  },
  {
    id: 2,
    name: 'Deploy Server',
    alg_type: 'RSA',
    addedAt: 'May 28, 2025',
    status: 'notOnServer',
    deletedFromServerAt: 'May 28, 2025',
  },
  {
    id: 3,
    name: 'Home Desktop',
    alg_type: 'ECDSA',
    addedAt: 'Apr 15, 2025',
    status: 'active',
  },
  {
    id: 4,
    name: 'Staging CI/CD',
    alg_type: 'ED25519',
    addedAt: 'Mar 3, 2025',
    status: 'active',
    deletedFromServerAt: 'Mar 3, 2025',
  },
  {
    id: 5,
    name: 'Backup Automation',
    alg_type: 'RSA',
    addedAt: 'Feb 9, 2025',
    status: 'active',
  },
];

//export const sshKeys: SSHKey[] = []

//notOnServer
